/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CenterGroupDto } from '../../models/center-group-dto';
import { CreateCenterGroupDto } from '../../models/create-center-group-dto';

export interface CenterGroupControllerCreateGroup$Params {
      body: CreateCenterGroupDto
}

export function centerGroupControllerCreateGroup(http: HttpClient, rootUrl: string, params: CenterGroupControllerCreateGroup$Params, context?: HttpContext): Observable<StrictHttpResponse<CenterGroupDto>> {
  const rb = new RequestBuilder(rootUrl, centerGroupControllerCreateGroup.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CenterGroupDto>;
    })
  );
}

centerGroupControllerCreateGroup.PATH = '/api/center-group';
